<template>
  <g
    class="borderArea"
  >
    <polygon
      v-if="borderArea"
      ref="borderAreaPolygon"
      :points="createPolygon(borderArea)"
      :stroke-width="`${ 3 * zoomFactor }px`"
      :stroke="color"
      class="area"
      stroke-linejoin="round"
    />
    <template v-if="edit">
      <circle
        v-for="(point, index) in borderArea"
        ref="pointHandle"
        :key="`point-${ index }`"
        :r="2 * zoomFactor"
        :cx="point.pan"
        :cy="-point.tilt"
        :stroke-width="2 * zoomFactor"
        :data-index="index"
        :index="index"
        class="point-handle cursor-move"
        fill="white"
        fill-opacity="0.5"
        stroke="darkgray"
      />
    </template>
  </g>
</template>

<script>
import interact from 'interactjs';

export default {
  name: 'BorderArea',
  props: {
    borderArea: {
      type: Array,
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default () {
        return "lightcoral";
      }
    },
    scale: {
      type: Object,
      required: false,
      default: () => ({
        scaleX: 1,
        scaleY: 1,
      })
    },
    zoomFactor: {
      type: Number,
      required: false,
      default () {
        return 1;
      }
    },
  },
  mounted: function () {
    this.addDraggable();
  },
  beforeDestroy: function () {
    this.removeDraggable();
  },
  methods: {
    update () {
      this.$nextTick(() => {
        this.removeDraggable();
        this.addDraggable();
      });
    },
    createPolygon (positions) {
      if (!positions.length) {
        return '';
      }

      if (typeof positions[0].pan === 'undefined') {
        return '';
      }
      let result = ``;
      for (let index = 0; index < positions.length; index++) {
        result = `${ result } ${ positions[index].pan },${ -positions[index].tilt }`;
      }
      return result;
    },
    round (number) {
      //Round values to 2 decimal digits
      return Math.round(number * 1e2) / 1e2;
    },
    removeDraggable () {
      if (!this.edit) {
        return;
      }

      if (this.$refs.pointHandle) {
        this.$refs.pointHandle.forEach(o => {
          interact(o).unset();
        });
      }
    },
    addDraggable () {
      if (!this.edit) {
        return;
      }

      if (!this.$refs.pointHandle || !this.$refs.pointHandle.length)
      {
        return;
      }

      this.$refs.pointHandle.forEach(o => {
        interact(o)
        .draggable({ max: Infinity, restrict: { elementRect: { top: 0, left: 0, bottom: 1, right: 1 } },
          onmove: (event) => {
            let index = event.target.attributes.index.value;
            this.borderArea[index].pan += event.dx * this.scale.scaleX;
            this.borderArea[index].tilt -= event.dy * this.scale.scaleY;
            if(this.round(this.borderArea[index].pan) > 170) {
              this.borderArea[index].pan = 170;
            }
            else if(this.round(this.borderArea[index].pan) < -170) {
              this.borderArea[index].pan = -170;
            }
            else {
              this.borderArea[index].pan = this.round(this.borderArea[index].pan);
            }

            if(this.round(this.borderArea[index].tilt) > 80) {
              this.borderArea[index].tilt = 80;
            }
            else if(this.round(this.borderArea[index].tilt) < -80) {
              this.borderArea[index].tilt = -80;
            }
            else {
              this.borderArea[index].tilt = this.round(this.borderArea[index].tilt);
            }
            this.$emit('changePtz', this.borderArea[index]);
          }
        });
      });
    },
  }
}
</script>

<style scoped>
g {
  opacity: 0.8;
}
g circle {
  opacity: 0.7;
}
.area {
  fill: none;
}
</style>
